import React from 'react';
import Header from '../components/menu/header';
import Footer from '../components/menu/footer';
import PublicBottomBar from '../components/menu/PublicBottomBar';
import './homePage.css';

const HomePage = () => {
  return (
    <div className="home-page">
      <Header />

      {/* Hero Section — struttura invariata */}
      <section className="hero">
        <div className="hero-content">
          <h1>SCOUTBALLITALIA</h1>
          <p>IL PORTALE ITALIANO DELLO SCOUTBALL</p>
        </div>
      </section>

      <Footer />
      <PublicBottomBar />
    </div>
  );
};

export default HomePage;
